(() => {
  function initialise(root) {
    if (root.dataset.saInitialised) return;
    root.dataset.saInitialised = 'true';
    const config = JSON.parse(root.querySelector('.sa-award-config').textContent);
    const sample = root.querySelector('.sa-print-sample');
    sample?.querySelector('.sa-sample-close').addEventListener('click', () => sample.close());
    sample?.addEventListener('click', event => { if (event.target === sample) sample.close(); });
    const note = (element, text, className = 'sa-award-field-note') => {
      if (!element || element.querySelector('.' + className)) return;
      const p = document.createElement('p');
      p.className = className;
      p.textContent = text;
      element.append(p);
    };
    root.addEventListener('change', () => requestAnimationFrame(decorate));
    function decorate() {
      const badge = root.querySelector('.sa-badge-order');
      if (badge) {
        const personalise = badge.querySelector('input[name="properties[Badge personalisation]"]:checked')?.value !== 'Blank';
        const details = badge.querySelector('.sa-badge-details');
        details.hidden = !personalise;
        details.querySelectorAll('input, textarea').forEach(input => { input.disabled = !personalise; });
        const list = badge.querySelector('.sa-badge-list');
        const artwork = badge.querySelector('input[name="properties[Badge artwork]"]');
        badge.querySelector('.sa-badge-text').required = personalise && !list.files.length && !artwork.files.length;
        details.querySelectorAll('input[type="file"]').forEach(input => input.setCustomValidity(input.files[0]?.size > 10 * 1024 * 1024 ? config.badgeFileTooLarge : ''));
        const selectedId = root.querySelector('.js-product-form-main input[name="id"]')?.value;
        const variant = config.variants.find(variant => String(variant.id) === String(selectedId));
        const customColour = variant?.option1 === 'CMYK';
        const colour = badge.querySelector('.sa-badge-colour');
        colour.hidden = !customColour;
        colour.querySelector('input').disabled = !customColour;
        colour.querySelector('input').required = customColour;
      }
      const trayBox = root.querySelector('.sa-tray-box:not(.sa-glass-box):not(.sa-flask-box)');
      if (trayBox) {
        const selectedId = root.querySelector('.js-product-form-main input[name="id"]')?.value;
        const match = config.trayBoxes?.find(box => String(box.trayId) === String(selectedId));
        trayBox.hidden = !match;
        const checkbox = trayBox.querySelector('.sa-tray-box-input');
        if (match) {
          const text = config.trayBoxFit.replace('[tray_size]', match.size).replace('[box_size]', match.boxSize);
          const size = trayBox.querySelector('.sa-tray-box-size');
          if (size.textContent !== text) size.textContent = text;
          const price = trayBox.querySelector('.sa-tray-box-price');
          const amount = '+' + match.priceText + ' ' + config.boxEach;
          if (price.textContent !== amount) price.textContent = amount;
          const image = trayBox.querySelector('img');
          if (image.getAttribute('src') !== match.image) image.src = match.image;
        } else checkbox.checked = false;
      }
      const glassBox = root.querySelector('.sa-glass-box');
      if (glassBox) {
        const selectedId = root.querySelector('.js-product-form-main input[name="id"]')?.value;
        const match = config.glassBoxes?.find(box => String(box.glassId) === String(selectedId));
        glassBox.hidden = !match;
        if (match) {
          const size = glassBox.querySelector('.sa-glass-box-size');
          const text = match.title + ' · ' + match.sku + ' · ' + match.boxSize;
          if (size.textContent !== text) size.textContent = text;
          const price = glassBox.querySelector('.sa-glass-box-price');
          const amount = '+' + match.priceText + ' ' + config.boxEach;
          if (price.textContent !== amount) price.textContent = amount;
          const image = glassBox.querySelector('img');
          if (image.getAttribute('src') !== match.image) image.src = match.image;
        } else glassBox.querySelector('.sa-glass-box-input').checked = false;
      }
      const flaskBox = root.querySelector('.sa-flask-box');
      if (flaskBox) {
        const selectedId = root.querySelector('.js-product-form-main input[name="id"]')?.value;
        const matches = config.flaskBoxes?.filter(box => String(box.flaskId) === String(selectedId)) || [];
        flaskBox.hidden = matches.length === 0;
        flaskBox.querySelectorAll('.sa-flask-box-choice').forEach(choice => {
          const input = choice.querySelector('input');
          const compatible = matches.some(box => String(box.id) === input.value);
          choice.hidden = !compatible;
          input.disabled = !compatible;
          if (!compatible && input.checked) flaskBox.querySelector('input[value=""]').checked = true;
        });
      }
      if (config.workflow === 'medal_box' || config.workflow === 'packaging') {
        root.querySelectorAll('.hulkapps_product_options').forEach(options => options.remove());
      }
      const price = root.querySelector('.product-info__price');
      if (price && !price.querySelector('.sa-price-each')) {
        const each = document.createElement('span');
        each.className = 'sa-price-each';
        each.textContent = config.each;
        price.append(each);
      }
      const legend = root.querySelector('variant-picker legend');
      if (config.singleOption && config.workflow === 'corporate' && legend && /Size|Variant/i.test(legend.textContent) && legend.textContent !== config.sizeLabel) legend.textContent = config.sizeLabel;
      root.querySelectorAll('variant-picker .opt-label').forEach(label => {
        const input = document.getElementById(label.htmlFor);
        const variant = config.variants.find(v => v.option1 === input?.value);
        if (config.singleOption && variant && !label.querySelector('.sa-size-price')) {
          const price = document.createElement('small');
          price.className = 'sa-size-price';
          price.textContent = new Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD'}).format(variant.price / 100);
          label.append(price);
        }
      });
      const custom = root.querySelector('#customization');
      if (custom) {
        const title = custom.querySelector('.hulkapps_option_name');
        if (title && !title.dataset.saLabel) {
          const text = [...title.childNodes].find(n => n.nodeType === 3);
          if (text) text.textContent = config.personaliseLabel + ' ';
          title.setAttribute('aria-label', config.personaliseLabel);
          title.dataset.saLabel = 'true';
        }
        custom.querySelectorAll('.radio_div').forEach(div => {
          const value = div.parentElement.querySelector('input')?.value;
          const display = value === 'Yes' ? config.yes : config.no;
          if (div.textContent !== display) div.textContent = display;
        });
      }
      const decoration = config.workflow === 'corporate' ? root.querySelector('#Digital-printing') : null;
      if (decoration) {
        const title = decoration.querySelector('.hulkapps_option_name');
        if (title && !title.dataset.saLabel) {
          title.textContent = config.decoration;
          title.setAttribute('aria-label', config.decoration);
          title.dataset.saLabel = 'true';
        }
        decoration.querySelectorAll('.hulkapps_radio_option').forEach(label => {
          note(label, label.querySelector('input')?.value === 'Laser Etching' ? config.laserNote : config.printNote, 'sa-finish-note');
        });
        if (sample && !decoration.querySelector('.sa-sample-trigger')) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'sa-sample-trigger';
          button.textContent = config.sampleLink;
          button.setAttribute('aria-haspopup', 'dialog');
          button.setAttribute('aria-controls', sample.id);
          button.addEventListener('click', () => sample.showModal());
          decoration.append(button);
        }
      }
      note(root.querySelector('#engraving-text'), config.engravingNote);
      const logo = root.querySelector('#logo');
      if (logo && config.workflow === 'corporate' && !root.querySelector('#logouploadquestions')) {
        logo.classList.remove('required', 'validation_error');
        const title = logo.querySelector('.hulkapps_option_name');
        if (title && title.textContent !== config.logoLabel) title.textContent = config.logoLabel;
        if (title && title.getAttribute('aria-required') !== 'false') title.setAttribute('aria-required', 'false');
        if (title && title.getAttribute('aria-label') !== config.logoLabel) title.setAttribute('aria-label', config.logoLabel);
        const input = logo.querySelector('input[type="file"]');
        if (input) input.required = false;
        note(logo, config.logoNote);
      }
      note(root.querySelector('#uploadbulkradio'), config.bulkNote);
      if (config.workflow === 'medal') root.querySelectorAll('.swatch_render').forEach(option => {
        if (option.querySelector('.sa-ribbon-dialog') && config.boxes?.length) {
          const boxed = root.dataset.saPresentation === 'box';
          option.classList.toggle('required', !boxed);
          if (boxed) option.classList.remove('validation_error');
          const name = option.querySelector('.hulkapps_option_name');
          if (name && name.getAttribute('aria-required') !== String(!boxed)) name.setAttribute('aria-required', String(!boxed));
          option.querySelectorAll('.sa-ribbon-dialog input').forEach(input => { input.disabled = boxed; });
        }
        const title = option.querySelector('.hulkapps_option_name')?.textContent || '';
        if (!/ribbon/i.test(title) || option.querySelector('.sa-ribbon-dialog')) return;
        const values = option.querySelector('.hulkapps_option_value');
        if (!values) return;
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'sa-ribbon-trigger';
        trigger.setAttribute('aria-haspopup', 'dialog');
        const dialog = document.createElement('dialog');
        dialog.className = 'sa-ribbon-dialog';
        dialog.id = 'sa-ribbons-' + (option.dataset.parentId || config.variants[0].id);
        trigger.setAttribute('aria-controls', dialog.id);
        const heading = document.createElement('h2');
        heading.id = dialog.id + '-title';
        heading.textContent = config.ribbonTitle;
        dialog.setAttribute('aria-labelledby', heading.id);
        const intro = document.createElement('p');
        intro.textContent = config.ribbonIntro;
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'sa-sample-close';
        close.textContent = '×';
        close.setAttribute('aria-label', config.ribbonClose);
        close.addEventListener('click', () => dialog.close());
        dialog.append(close, heading, intro, values);
        option.append(trigger, dialog);
        let boxTrigger, boxDialog;
        const selectRibbon = () => {
          delete root.dataset.saBoxVariant;
          root.dataset.saPresentation = 'ribbon';
          if (boxTrigger) { boxTrigger.classList.remove('sa-ribbon-chosen'); boxTrigger.textContent = config.boxChoose; }
          option.classList.add('required');
          option.querySelectorAll('input').forEach(input => { input.disabled = false; });
        };
        if (config.boxes?.length) {
          const name = option.querySelector('.hulkapps_option_name');
          if (name) name.textContent = config.presentationTitle;
          const choices = document.createElement('div');
          choices.className = 'sa-presentation-choices';
          boxTrigger = document.createElement('button');
          boxTrigger.type = 'button';
          boxTrigger.className = 'sa-ribbon-trigger sa-box-trigger';
          boxTrigger.textContent = config.boxChoose;
          boxTrigger.setAttribute('aria-haspopup', 'dialog');
          choices.append(trigger, boxTrigger);
          option.insertBefore(choices, dialog);
          boxDialog = document.createElement('dialog');
          boxDialog.className = 'sa-ribbon-dialog sa-box-dialog';
          boxDialog.id = dialog.id + '-boxes';
          boxTrigger.setAttribute('aria-controls', boxDialog.id);
          const heading = document.createElement('h2');
          heading.id = boxDialog.id + '-title';
          heading.textContent = config.boxTitle;
          boxDialog.setAttribute('aria-labelledby', heading.id);
          const intro = document.createElement('p');
          intro.textContent = config.boxIntro;
          const close = document.createElement('button');
          close.type = 'button'; close.className = 'sa-sample-close'; close.textContent = '×';
          close.setAttribute('aria-label', config.ribbonClose);
          close.addEventListener('click', () => boxDialog.close());
          const grid = document.createElement('div'); grid.className = 'sa-box-grid';
          config.boxes.forEach(box => {
            const button = document.createElement('button');
            button.type = 'button'; button.className = 'sa-box-card';
            const image = document.createElement('img'); image.src = box.image; image.alt = box.title; image.loading = 'lazy';
            const title = document.createElement('strong'); title.textContent = box.title;
            const price = document.createElement('span'); price.textContent = '+' + box.priceText + ' ' + config.boxEach;
            button.append(image, title, price);
            button.addEventListener('click', () => {
              root.dataset.saBoxVariant = String(box.id);
              root.dataset.saPresentation = 'box';
              values.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = false; });
              option.querySelectorAll('input[name^="properties["]').forEach(input => { input.value = ''; input.disabled = true; });
              option.classList.remove('required', 'validation_error');
              trigger.classList.remove('sa-ribbon-chosen'); trigger.textContent = config.ribbonChoose;
              boxTrigger.textContent = box.title + ' · +' + box.priceText + ' ' + config.boxEach;
              boxTrigger.classList.add('sa-ribbon-chosen');
              grid.querySelectorAll('.sa-box-card').forEach(card => card.classList.toggle('is-selected', card === button));
              boxDialog.close();
            });
            grid.append(button);
          });
          boxDialog.append(close, heading, intro, grid);
          option.append(boxDialog);
          custom?.addEventListener('change', () => {
            if (custom.querySelector('input[type="radio"]:checked')?.value === 'No') {
              selectRibbon();
              grid.querySelectorAll('.sa-box-card').forEach(card => card.classList.remove('is-selected'));
            }
          });
          boxTrigger.addEventListener('click', () => boxDialog.showModal());
          boxDialog.addEventListener('click', event => { if (event.target === boxDialog) boxDialog.close(); });
          boxDialog.addEventListener('close', () => boxTrigger.focus());
        }
        const update = () => {
          const selected = values.querySelector('input[type="radio"]:checked');
          trigger.textContent = selected ? config.ribbonSelected + ': ' + selected.value + ' · ' + config.ribbonChange : config.ribbonChoose;
          trigger.classList.toggle('sa-ribbon-chosen', !!selected);
        };
        trigger.addEventListener('click', () => { selectRibbon(); dialog.showModal(); });
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
        dialog.addEventListener('close', () => { update(); trigger.focus(); });
        values.addEventListener('click', event => {
          if (!event.target.closest('.hulkapps_swatch_option')) return;
          requestAnimationFrame(() => {
            update();
            if (values.querySelector('input[type="radio"]:checked')) dialog.close();
          });
        });
        values.addEventListener('change', update);
        update();
      });
      root.querySelectorAll('.swatch_render .hulkapps_swatch_option').forEach(label => {
        if (label.querySelector('.sa-swatch-name')) return;
        const name = label.getAttribute('aria-label')?.trim();
        if (!name) return;
        const text = document.createElement('span');
        text.className = 'sa-swatch-name';
        text.textContent = name;
        label.append(text);
      });
      let step = 0;
      root.querySelectorAll('.sa-award-step').forEach(heading => {
        const panel = heading.closest('.sa-award-personalise');
        if (panel && !panel.querySelector('.hulkapps_option')) return;
        const number = heading.querySelector('span');
        const value = String(++step);
        if (number.textContent !== value) number.textContent = value;
      });
      const specLink = root.querySelector('.sa-spec-link');
      if (specLink && !document.getElementById('sa-award-specifications')) specLink.hidden = true;
      const textarea = root.querySelector('#engraving-text textarea');
      if (textarea && !textarea.getAttribute('aria-label')) textarea.setAttribute('aria-label', root.querySelector('#engraving-text .hulkapps_option_name').textContent.trim());
      if (textarea) {
        textarea.setAttribute('spellcheck', 'true');
        textarea.setAttribute('lang', 'en-AU');
        textarea.setAttribute('autocorrect', 'off');
      }
      const addon = root.querySelector('#option_total');
      note(addon, config.addonNote);
      root.querySelectorAll('.hulkapps_option').forEach(option => {
        const error = option.querySelector('.sa-award-error-note');
        if (option.classList.contains('validation_error')) {
          note(option, config.requiredNote, 'sa-award-error-note');
          option.querySelector('.sa-award-error-note')?.setAttribute('role', 'alert');
        } else if (error) error.remove();
      });
      const bulk = root.querySelector('.hulk-custom-table-container');
      const media = root.querySelector('.product-media');
      if (bulk && media && !root.querySelector('.sa-award-bulk')) {
        const details = document.createElement('details');
        details.className = 'sa-award-bulk';
        details.open = true;
        const summary = document.createElement('summary');
        const text = document.createElement('span');
        const heading = document.createElement('strong');
        heading.textContent = config.bulkTitle;
        const subtitle = document.createElement('small');
        subtitle.textContent = config.bulkSubtitle;
        text.append(heading, subtitle);
        const indicator = document.createElement('span');
        indicator.className = 'sa-bulk-indicator';
        indicator.textContent = '+';
        indicator.setAttribute('aria-hidden', 'true');
        summary.append(text, indicator);
        details.append(summary, bulk);
        const help = media.querySelector('.sa-award-help');
        media.insertBefore(details, help);
      }
      const breakdown = root.querySelector('.sa-award-bulk');
      const priceBlock = root.querySelector('.product-price');
      if (breakdown && priceBlock && !priceBlock.querySelector('.sa-pricing-link')) {
        breakdown.id = 'sa-pricing-breakdown-' + config.variants[0].id;
        const link = document.createElement('a');
        link.className = 'sa-pricing-link';
        link.href = '#' + breakdown.id;
        link.textContent = config.bulkLink + ' ↓';
        link.addEventListener('click', event => {
          event.preventDefault();
          breakdown.open = true;
          requestAnimationFrame(() => {
            const header = document.querySelector('.cc-header--sticky');
            const offset = (header ? header.getBoundingClientRect().height : 0) + 20;
            const targetRect = breakdown.getBoundingClientRect();
            let top = window.scrollY + targetRect.top - offset;
            if (media && getComputedStyle(media).position === 'sticky') {
              const mediaRect = media.getBoundingClientRect();
              const parentRect = media.parentElement.getBoundingClientRect();
              const parentPadding = parseFloat(getComputedStyle(media.parentElement).paddingBottom) || 0;
              top = window.scrollY + parentRect.bottom - parentPadding - mediaRect.height + targetRect.top - mediaRect.top - offset;
            }
            if (location.hash !== link.hash) history.pushState(null, '', link.hash);
            breakdown.querySelector('summary').focus({preventScroll: true});
            window.scrollTo({top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          });
        });
        priceBlock.append(link);
      }
    }
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; decorate(); });
    });
    observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
    decorate();
  }
  function init() { document.querySelectorAll('.sa-award-page').forEach(initialise); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();



